<template>
  <v-row justify="center">
    <v-dialog max-width="500px" persistent v-model="showPopup.show">
      <v-form ref="form">
        <v-card>
          <v-card-title class="blue" primary-title>
            <v-icon class="pa-1 mr-1" color="blue darken-4"
              >fa-solid fa-upload</v-icon
            >
            <span>Provisioning</span>
          </v-card-title>
          <v-card-text class="headline ma-1"> Sind Sie sicher? </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="showPopup.show = false" color="blue darken-1" text
              >Nein</v-btn
            >
            <v-btn
              :loading="loading"
              @click="submit"
              color="green darken-1"
              text
              >Ja</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { HTTP } from "../http";
import { EventBus } from "../eventbus";

export default {
  props: {
    showPopup: Object,
    customer: Object,
  },
  data() {
    return {
      loading: false,
       localCustomer:
                    {
                        CustomerID: this.customer.CustomerID,
                        Email: this.customer.Email,
                        AP: this.customer.AP,
                        Firma: this.customer.Firma,
                        Strasse: this.customer.Strasse,
                        PLZ: this.customer.PLZ,
                        Ort: this.customer.Ort,
                        Land: this.customer.Land,
                        Telefon: this.customer.Telefon,
                        Kommentar: this.customer.Kommentar
                    },
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        HTTP.post("api/Provision", this.localCustomer)
          .then(() => {
            EventBus.$emit("reload");
            this.showPopup.show = false;
          })
          .finally(()=>this.loading=false);

    
      }
    },
  },
};
</script>
